import React from 'react';


//CORE COMPONENTS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';

//LAYOUT
import { 
    Container, 
    ContainerPadding,
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Text, TextAppearance } from '../../../components-core/packages/components-core/dist';


class LeftPaddingHeadline extends React.Component {
    render() {
        const { custom1, custom2 } = this.props;

        return (
            <ThemeProvider>
                <Container padding={containerPadding}>
                    <h2><Text appearance={TextAppearance.headline0400}>
                        {custom1}
                        <Text bold>{' ' + custom2}</Text>
                    </Text>
                    </h2>
                </Container>
            </ThemeProvider>
        )
    }
}

const containerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1600]: ContainerPadding.grid005
    },
    right: {
        [Breakpoints.default]: ContainerPadding.grid002,
        [Breakpoints.b960]: ContainerPadding.grid004,
        [Breakpoints.b1600]: ContainerPadding.grid005
    },
    top: ContainerPadding.dynamic0300
}

export default LeftPaddingHeadline;